export enum ThirdPartySsoDataLogStatus {
    failed = 'failed',
    failedToParse = 'failed-to-parse',
    notIncluded = 'not-included',
    success = 'success',
}
